<template>
  <div class="modal-custom-k">
    <div class="modal-content-custom">
      <div class="modal-box-custom animate__animated animate__fadeInRight">
        <div class="modal-header-custom">
          <h1 class="modal-header-text">
            {{ title }}
          </h1>
          <feather type="x" size="20px" class="modal-icon-custom"
                   @click="$emit('closemodal')"
          />
        </div>
        <div class="modal-container-custom">
          <b-field label="Descrição" custom-class="is-small">
            <b-input v-model="modalData[0]" size="is-small" />
          </b-field>
          <b-field
            label="Vincular às condições de pagamento"
            custom-class="is-small"
          >
            <treeselect
              v-model="modalData[1]"
              :multiple="true"
              :async="true"
              :load-options="loadOptions"
              size="is-small"
            />
          </b-field>
          <b-field
            label="Vincular às empresas"
            custom-class="is-small"
          >
            <treeselect
              v-model="modalData[2]"
              :multiple="true"
              :async="true"
              :load-options="loadOptionsEmp"
              size="is-small"
            />
          </b-field>
          <b-field
            label="Tipo"
            custom-class="is-small"
          >
            <treeselect
              v-model="modalData[3]"
              :multiple="false"
              :async="true"
              :load-options="tipoOptions"
              size="is-small"
            />
          </b-field>
          <div class="container-id">
            <b-field label="Associado ID" custom-class="is-small">
              <b-input v-model="modalData[4]" class="b-field-input-tree" size="is-small" />
            </b-field>
            <b-field label="Integração ID" custom-class="is-small">
              <b-input v-model="modalData[5]" class="b-field-input-tree" size="is-small" />
            </b-field>
          </div>

          <b-field
            label="Status"
            custom-class="is-small"
          >
            <div class="field">
              <b-switch v-model="modalData[6]"
                        :true-value="1"
                        :false-value="0"
                        size="is-small"
              >
                {{ (modalData[6] === 0) ? 'Inativo' : 'Ativo' }}
              </b-switch>
            </div>
          </b-field>
          <div class="button-container">
            <b-button type="is-success" size="is-small" style="width:30%;"
                      @click="sendModalData"
            >
              Aplicar
            </b-button>

            <b-button type="is-danger" size="is-small" style="width:30%;margin-left:20px;">
              Cancelar
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

const simulateAsyncOperation = (fn) => {
	setTimeout(fn, 0);
};

export default {
	components: {
		Treeselect,
	},
	props: {
		title: {
			type: String,
			default: 'Editar',
		},
		getmodalData: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			modalData: [],
			condpgtos: [],
			id: '',
			descricao: '',
			associado_id: '',
			integracao_id: '',
			tipo: '',
			status: '',
			name: '',
			checkboxGroup: '',
			additional_grouped: [],
		};
	},
	computed: {
		myCondPg() {
			return this.condpgtos;
		},
	},
	watch: {
		/*   additional_grouped: (value) => {
      this.additional_grouped = [];
      this.additional_grouped = value;
    }, */
	},
	methods: {
		sendModalData() {
			if (this.modalData && this.modalData.length === 7) {
				const modalMountVar = {
					associado_id: parseInt(this.modalData[4], 10),
					condpgto: this.modalData[1],
					descricao: this.modalData[0],
					empresa: this.modalData[2],
					integracao_id: this.modalData[5],
					status: (this.modalData[6] === 'Ativo') ? '0' : '1',
					tipo: this.modalData[3],
				};
				this.$emit('savedata', modalMountVar);
			} else {
				this.$buefy.notification.open({
					message: 'Erro ao verificar variáveis',
					type: 'is-danger',
				});
			}
		},
		uniqueCheck(e) {
			this.additional_grouped = [];
			if (e.target.checked) {
				this.additional_grouped.push(e.target.value);
			}
		},
		tipoOptions({ action, searchQuery, callback }) {
			if (action === ASYNC_SEARCH) {
				simulateAsyncOperation(() => {
					const condpgtosResult = [];
					this.getmodalData.tipoOptions.map((i) => {
						if (i.label.includes(searchQuery.toUpperCase())) {
							condpgtosResult.push({
								id: i.id,
								label: i.label,
							});
							return true;
						}
						return false;
					});
					callback(null, condpgtosResult);
				});
			}
		},
		loadOptionsEmp({ action, searchQuery, callback }) {
			if (action === ASYNC_SEARCH) {
				simulateAsyncOperation(() => {
					const condpgtosResult = [];
					this.getmodalData.empresas.map((i) => {
						if (i.fantasia.includes(searchQuery.toUpperCase())) {
							condpgtosResult.push({
								id: i.id,
								label: i.fantasia,
							});
							return true;
						}
						return false;
					});
					callback(null, condpgtosResult);
				});
			}
		},
		loadOptions({ action, searchQuery, callback }) {
			if (action === ASYNC_SEARCH) {
				simulateAsyncOperation(() => {
					const condpgtosResult = [];
					this.getmodalData.condpgtos.map((i) => {
						if (i.descricao.includes(searchQuery)) {
							condpgtosResult.push({
								id: i.id,
								label: i.descricao,
							});
							return true;
						}
						return false;
					});
					callback(null, condpgtosResult);
				});
			}
		},
	},
};
</script>

<style scoped>

.b-field-input-tree {
  margin-right: 10px;
  margin-left: 10px;
}

.modal-container-custom {
    padding: 20px;
}
.container-id {
  width: 100%;
  justify-content: space-between;
  display: flex;
}
.modal-icon-custom {
  cursor: pointer;
}
.modal-custom-k {
   position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.137);
  display: table;
  transition: all 0.5s ease;
  overflow-y: scroll;
  align-items: flex-end;
}
.button-container {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
}
.modal-content-custom {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    width: 100%;
    height: 100%;
    transition: all 0.5s ease;
}
.modal-box-custom {
    transition: all 0.5s ease;
    width: 450px;
    height: 100%;
    background-color: #FFF;
}
.modal-header-custom {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(223, 223, 223, 0.342);
}
.modal-header-text {
    font-size: 20px;
}

</style>
